import React, { memo, useMemo } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { createUseStyles } from '@Sage/hoi-poi-ui';

import styles from './styles.js';

const useStyles = createUseStyles(styles, 'S200ukiOnboardingLayout');

const S200ukiOnboardingLayout = ({ bgImgSrc, children, className }) => {
    const classes = useStyles();

    const rootStyle = useMemo(() => {
        if (!bgImgSrc) return undefined;
        return {
            backgroundImage: `url(${bgImgSrc})`,
        };
    }, [bgImgSrc]);

    return (
        <div
            className={classNames(classes.pageRoot, className, {
                [classes.pageRootWithBg]: Boolean(bgImgSrc),
            })}
            style={rootStyle}
        >
            {children}
        </div>
    );
};

S200ukiOnboardingLayout.propTypes = {
    bgImgSrc: PropTypes.string,
    children: PropTypes.node,
    className: PropTypes.string,
};

S200ukiOnboardingLayout.displayName = 'S200ukiOnboardingLayout';

export default memo(S200ukiOnboardingLayout);
